/* box.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._30huDKYbGa%7Bborder%3Anone%7D%0A._24h04i2Njc%7Bbox-sizing%3Aborder-box%7D%0A._034jHtYbGa%7B-webkit-appearance%3Anone%3B-moz-appearance%3Anone%3Bappearance%3Anone%7D%0A._0KLXruXL80%7Bbackground-color%3Avar(--ds-background-accent-lime-subtlest%2C%23efffd6)%7D%0A._0KLXruL7r8%7Bbackground-color%3Avar(--ds-background-accent-lime-subtlest-hovered%2C%23d3f1a7)%7D%0A._0KLXrulDnJ%7Bbackground-color%3Avar(--ds-background-accent-lime-subtlest-pressed%2C%23bde97c)%7D%0A._0KLXruuKDS%7Bbackground-color%3Avar(--ds-background-accent-lime-subtler%2C%23d3f1a7)%7D%0A._0KLXruuIDk%7Bbackground-color%3Avar(--ds-background-accent-lime-subtler-hovered%2C%23bde97c)%7D%0A._0KLXruyTNr%7Bbackground-color%3Avar(--ds-background-accent-lime-subtler-pressed%2C%23b3df72)%7D%0A._0KLXruZcd0%7Bbackground-color%3Avar(--ds-background-accent-lime-subtle%2C%2394c748)%7D%0A._0KLXrude7x%7Bbackground-color%3Avar(--ds-background-accent-lime-subtle-hovered%2C%23b3df72)%7D%0A._0KLXrum9Fz%7Bbackground-color%3Avar(--ds-background-accent-lime-subtle-pressed%2C%23bde97c)%7D%0A._0KLXrubYhN%7Bbackground-color%3Avar(--ds-background-accent-lime-bolder%2C%235b7f24)%7D%0A._0KLXruaWdC%7Bbackground-color%3Avar(--ds-background-accent-lime-bolder-hovered%2C%234c6b1f)%7D%0A._0KLXruCN3C%7Bbackground-color%3Avar(--ds-background-accent-lime-bolder-pressed%2C%233f5224)%7D%0A._0KLXrusDFP%7Bbackground-color%3Avar(--ds-background-accent-red-subtlest%2C%23ffeceb)%7D%0A._0KLXruIg5O%7Bbackground-color%3Avar(--ds-background-accent-red-subtlest-hovered%2C%23ffd5d2)%7D%0A._0KLXruElzn%7Bbackground-color%3Avar(--ds-background-accent-red-subtlest-pressed%2C%23ffb8b2)%7D%0A._0KLXrubV9i%7Bbackground-color%3Avar(--ds-background-accent-red-subtler%2C%23ffd5d2)%7D%0A._0KLXruFOVf%7Bbackground-color%3Avar(--ds-background-accent-red-subtler-hovered%2C%23ffb8b2)%7D%0A._0KLXruFnU8%7Bbackground-color%3Avar(--ds-background-accent-red-subtler-pressed%2C%23fd9891)%7D%0A._0KLXru0cUQ%7Bbackground-color%3Avar(--ds-background-accent-red-subtle%2C%23f87168)%7D%0A._0KLXruIt8U%7Bbackground-color%3Avar(--ds-background-accent-red-subtle-hovered%2C%23fd9891)%7D%0A._0KLXrunRhf%7Bbackground-color%3Avar(--ds-background-accent-red-subtle-pressed%2C%23ffb8b2)%7D%0A._0KLXruQrW1%7Bbackground-color%3Avar(--ds-background-accent-red-bolder%2C%23c9372c)%7D%0A._0KLXrumCVf%7Bbackground-color%3Avar(--ds-background-accent-red-bolder-hovered%2C%23ae2e24)%7D%0A._0KLXruPm25%7Bbackground-color%3Avar(--ds-background-accent-red-bolder-pressed%2C%23872821)%7D%0A._0KLXru2QQR%7Bbackground-color%3Avar(--ds-background-accent-orange-subtlest%2C%23fff5db)%7D%0A._0KLXru629A%7Bbackground-color%3Avar(--ds-background-accent-orange-subtlest-hovered%2C%23fce4a6)%7D%0A._0KLXrupg0Z%7Bbackground-color%3Avar(--ds-background-accent-orange-subtlest-pressed%2C%23fbd779)%7D%0A._0KLXruwJ86%7Bbackground-color%3Avar(--ds-background-accent-orange-subtler%2C%23fce4a6)%7D%0A._0KLXruEo5I%7Bbackground-color%3Avar(--ds-background-accent-orange-subtler-hovered%2C%23fbd779)%7D%0A._0KLXru78bI%7Bbackground-color%3Avar(--ds-background-accent-orange-subtler-pressed%2C%23fbc828)%7D%0A._0KLXruuwVU%7Bbackground-color%3Avar(--ds-background-accent-orange-subtle%2C%23fca700)%7D%0A._0KLXrunwBH%7Bbackground-color%3Avar(--ds-background-accent-orange-subtle-hovered%2C%23fbc828)%7D%0A._0KLXruKHmw%7Bbackground-color%3Avar(--ds-background-accent-orange-subtle-pressed%2C%23fbd779)%7D%0A._0KLXrux4f7%7Bbackground-color%3Avar(--ds-background-accent-orange-bolder%2C%23bd5b00)%7D%0A._0KLXruwYNk%7Bbackground-color%3Avar(--ds-background-accent-orange-bolder-hovered%2C%239e4c00)%7D%0A._0KLXruDYlO%7Bbackground-color%3Avar(--ds-background-accent-orange-bolder-pressed%2C%237a3b00)%7D%0A._0KLXru56u3%7Bbackground-color%3Avar(--ds-background-accent-yellow-subtlest%2C%23fef7c8)%7D%0A._0KLXruBwZU%7Bbackground-color%3Avar(--ds-background-accent-yellow-subtlest-hovered%2C%23f5e989)%7D%0A._0KLXruHN5H%7Bbackground-color%3Avar(--ds-background-accent-yellow-subtlest-pressed%2C%23efdd4e)%7D%0A._0KLXruLv9B%7Bbackground-color%3Avar(--ds-background-accent-yellow-subtler%2C%23f5e989)%7D%0A._0KLXruJMtC%7Bbackground-color%3Avar(--ds-background-accent-yellow-subtler-hovered%2C%23efdd4e)%7D%0A._0KLXruVvUp%7Bbackground-color%3Avar(--ds-background-accent-yellow-subtler-pressed%2C%23eed12b)%7D%0A._0KLXruC29w%7Bbackground-color%3Avar(--ds-background-accent-yellow-subtle%2C%23eed12b)%7D%0A._0KLXruSF9i%7Bbackground-color%3Avar(--ds-background-accent-yellow-subtle-hovered%2C%23ddb30e)%7D%0A._0KLXruOIUD%7Bbackground-color%3Avar(--ds-background-accent-yellow-subtle-pressed%2C%23efdd4e)%7D%0A._0KLXruYB6L%7Bbackground-color%3Avar(--ds-background-accent-yellow-bolder%2C%23946f00)%7D%0A._0KLXru5gSm%7Bbackground-color%3Avar(--ds-background-accent-yellow-bolder-hovered%2C%237f5f01)%7D%0A._0KLXruTjon%7Bbackground-color%3Avar(--ds-background-accent-yellow-bolder-pressed%2C%23614a05)%7D%0A._0KLXruV6wL%7Bbackground-color%3Avar(--ds-background-accent-green-subtlest%2C%23dcfff1)%7D%0A._0KLXruMqh8%7Bbackground-color%3Avar(--ds-background-accent-green-subtlest-hovered%2C%23baf3db)%7D%0A._0KLXruUxn0%7Bbackground-color%3Avar(--ds-background-accent-green-subtlest-pressed%2C%2397edc9)%7D%0A._0KLXruNUep%7Bbackground-color%3Avar(--ds-background-accent-green-subtler%2C%23baf3db)%7D%0A._0KLXruSZVv%7Bbackground-color%3Avar(--ds-background-accent-green-subtler-hovered%2C%2397edc9)%7D%0A._0KLXruratX%7Bbackground-color%3Avar(--ds-background-accent-green-subtler-pressed%2C%237ee2b8)%7D%0A._0KLXru50ZN%7Bbackground-color%3Avar(--ds-background-accent-green-subtle%2C%234bce97)%7D%0A._0KLXru6mZS%7Bbackground-color%3Avar(--ds-background-accent-green-subtle-hovered%2C%237ee2b8)%7D%0A._0KLXruIBxe%7Bbackground-color%3Avar(--ds-background-accent-green-subtle-pressed%2C%2397edc9)%7D%0A._0KLXrude1t%7Bbackground-color%3Avar(--ds-background-accent-green-bolder%2C%231f845a)%7D%0A._0KLXruB5SF%7Bbackground-color%3Avar(--ds-background-accent-green-bolder-hovered%2C%23216e4e)%7D%0A._0KLXruLYGL%7Bbackground-color%3Avar(--ds-background-accent-green-bolder-pressed%2C%2319573d)%7D%0A._0KLXruuBpz%7Bbackground-color%3Avar(--ds-background-accent-teal-subtlest%2C%23e7f9ff)%7D%0A._0KLXrugqYx%7Bbackground-color%3Avar(--ds-background-accent-teal-subtlest-hovered%2C%23c6edfb)%7D%0A._0KLXrufBlI%7Bbackground-color%3Avar(--ds-background-accent-teal-subtlest-pressed%2C%23b1e4f7)%7D%0A._0KLXrunfgW%7Bbackground-color%3Avar(--ds-background-accent-teal-subtler%2C%23c6edfb)%7D%0A._0KLXruA8mq%7Bbackground-color%3Avar(--ds-background-accent-teal-subtler-hovered%2C%23b1e4f7)%7D%0A._0KLXrujHQE%7Bbackground-color%3Avar(--ds-background-accent-teal-subtler-pressed%2C%239dd9ee)%7D%0A._0KLXrufjGw%7Bbackground-color%3Avar(--ds-background-accent-teal-subtle%2C%236cc3e0)%7D%0A._0KLXrubjxt%7Bbackground-color%3Avar(--ds-background-accent-teal-subtle-hovered%2C%239dd9ee)%7D%0A._0KLXruUDSb%7Bbackground-color%3Avar(--ds-background-accent-teal-subtle-pressed%2C%23b1e4f7)%7D%0A._0KLXruzHaB%7Bbackground-color%3Avar(--ds-background-accent-teal-bolder%2C%23227d9b)%7D%0A._0KLXrunc80%7Bbackground-color%3Avar(--ds-background-accent-teal-bolder-hovered%2C%23206a83)%7D%0A._0KLXruu11s%7Bbackground-color%3Avar(--ds-background-accent-teal-bolder-pressed%2C%231a5265)%7D%0A._0KLXruVva3%7Bbackground-color%3Avar(--ds-background-accent-blue-subtlest%2C%23e9f2fe)%7D%0A._0KLXruotmK%7Bbackground-color%3Avar(--ds-background-accent-blue-subtlest-hovered%2C%23cfe1fd)%7D%0A._0KLXruxyGe%7Bbackground-color%3Avar(--ds-background-accent-blue-subtlest-pressed%2C%23adcbfb)%7D%0A._0KLXrup9dS%7Bbackground-color%3Avar(--ds-background-accent-blue-subtler%2C%23cfe1fd)%7D%0A._0KLXruRRyT%7Bbackground-color%3Avar(--ds-background-accent-blue-subtler-hovered%2C%23adcbfb)%7D%0A._0KLXrueeqx%7Bbackground-color%3Avar(--ds-background-accent-blue-subtler-pressed%2C%238fb8f6)%7D%0A._0KLXru28sy%7Bbackground-color%3Avar(--ds-background-accent-blue-subtle%2C%23669df1)%7D%0A._0KLXruKSSk%7Bbackground-color%3Avar(--ds-background-accent-blue-subtle-hovered%2C%238fb8f6)%7D%0A._0KLXru40Rv%7Bbackground-color%3Avar(--ds-background-accent-blue-subtle-pressed%2C%23adcbfb)%7D%0A._0KLXrutfbE%7Bbackground-color%3Avar(--ds-background-accent-blue-bolder%2C%231868db)%7D%0A._0KLXruupqB%7Bbackground-color%3Avar(--ds-background-accent-blue-bolder-hovered%2C%231558bc)%7D%0A._0KLXru36Hh%7Bbackground-color%3Avar(--ds-background-accent-blue-bolder-pressed%2C%23144794)%7D%0A._0KLXruB8KG%7Bbackground-color%3Avar(--ds-background-accent-purple-subtlest%2C%23f8eefe)%7D%0A._0KLXrueJK9%7Bbackground-color%3Avar(--ds-background-accent-purple-subtlest-hovered%2C%23eed7fc)%7D%0A._0KLXruhT4j%7Bbackground-color%3Avar(--ds-background-accent-purple-subtlest-pressed%2C%23e3bdfa)%7D%0A._0KLXruWOdT%7Bbackground-color%3Avar(--ds-background-accent-purple-subtler%2C%23eed7fc)%7D%0A._0KLXrujgGS%7Bbackground-color%3Avar(--ds-background-accent-purple-subtler-hovered%2C%23e3bdfa)%7D%0A._0KLXruWgRz%7Bbackground-color%3Avar(--ds-background-accent-purple-subtler-pressed%2C%23d8a0f7)%7D%0A._0KLXruf89Q%7Bbackground-color%3Avar(--ds-background-accent-purple-subtle%2C%23c97cf4)%7D%0A._0KLXru46BV%7Bbackground-color%3Avar(--ds-background-accent-purple-subtle-hovered%2C%23d8a0f7)%7D%0A._0KLXruU9Hm%7Bbackground-color%3Avar(--ds-background-accent-purple-subtle-pressed%2C%23e3bdfa)%7D%0A._0KLXruhdss%7Bbackground-color%3Avar(--ds-background-accent-purple-bolder%2C%23964ac0)%7D%0A._0KLXruXxp4%7Bbackground-color%3Avar(--ds-background-accent-purple-bolder-hovered%2C%23803fa5)%7D%0A._0KLXru1L16%7Bbackground-color%3Avar(--ds-background-accent-purple-bolder-pressed%2C%23673286)%7D%0A._0KLXru8frT%7Bbackground-color%3Avar(--ds-background-accent-magenta-subtlest%2C%23ffecf8)%7D%0A._0KLXruWeuD%7Bbackground-color%3Avar(--ds-background-accent-magenta-subtlest-hovered%2C%23fdd0ec)%7D%0A._0KLXruK9iC%7Bbackground-color%3Avar(--ds-background-accent-magenta-subtlest-pressed%2C%23fcb6e1)%7D%0A._0KLXruXM4x%7Bbackground-color%3Avar(--ds-background-accent-magenta-subtler%2C%23fdd0ec)%7D%0A._0KLXrukPhQ%7Bbackground-color%3Avar(--ds-background-accent-magenta-subtler-hovered%2C%23fcb6e1)%7D%0A._0KLXruGjVz%7Bbackground-color%3Avar(--ds-background-accent-magenta-subtler-pressed%2C%23f797d2)%7D%0A._0KLXrupmfs%7Bbackground-color%3Avar(--ds-background-accent-magenta-subtle%2C%23e774bb)%7D%0A._0KLXruexkg%7Bbackground-color%3Avar(--ds-background-accent-magenta-subtle-hovered%2C%23f797d2)%7D%0A._0KLXruV3kb%7Bbackground-color%3Avar(--ds-background-accent-magenta-subtle-pressed%2C%23fcb6e1)%7D%0A._0KLXruxE6Y%7Bbackground-color%3Avar(--ds-background-accent-magenta-bolder%2C%23ae4787)%7D%0A._0KLXruPb8Y%7Bbackground-color%3Avar(--ds-background-accent-magenta-bolder-hovered%2C%23943d73)%7D%0A._0KLXruwQL0%7Bbackground-color%3Avar(--ds-background-accent-magenta-bolder-pressed%2C%2377325b)%7D%0A._0KLXrumhAQ%7Bbackground-color%3Avar(--ds-background-accent-gray-subtlest%2C%23f0f1f2)%7D%0A._0KLXruBee8%7Bbackground-color%3Avar(--ds-background-accent-gray-subtlest-hovered%2C%23dddee1)%7D%0A._0KLXruysrI%7Bbackground-color%3Avar(--ds-background-accent-gray-subtlest-pressed%2C%23b7b9be)%7D%0A._0KLXruG6qS%7Bbackground-color%3Avar(--ds-background-accent-gray-subtler%2C%23dddee1)%7D%0A._0KLXruXljP%7Bbackground-color%3Avar(--ds-background-accent-gray-subtler-hovered%2C%23b7b9be)%7D%0A._0KLXru6vdf%7Bbackground-color%3Avar(--ds-background-accent-gray-subtler-pressed%2C%238c8f97)%7D%0A._0KLXrueZ10%7Bbackground-color%3Avar(--ds-background-accent-gray-subtle%2C%238c8f97)%7D%0A._0KLXruY62e%7Bbackground-color%3Avar(--ds-background-accent-gray-subtle-hovered%2C%23b7b9be)%7D%0A._0KLXruvFnq%7Bbackground-color%3Avar(--ds-background-accent-gray-subtle-pressed%2C%23dddee1)%7D%0A._0KLXrurxgm%7Bbackground-color%3Avar(--ds-background-accent-gray-bolder%2C%236b6e76)%7D%0A._0KLXruW5tB%7Bbackground-color%3Avar(--ds-background-accent-gray-bolder-hovered%2C%23505258)%7D%0A._0KLXrunA18%7Bbackground-color%3Avar(--ds-background-accent-gray-bolder-pressed%2C%233b3d42)%7D%0A._0KLXruVrZW%7Bbackground-color%3Avar(--ds-background-disabled%2C%230515240f)%7D%0A._0KLXru7Cj1%7Bbackground-color%3Avar(--ds-background-input%2C%23fff)%7D%0A._0KLXruqWX3%7Bbackground-color%3Avar(--ds-background-input-hovered%2C%23f8f8f8)%7D%0A._0KLXruutHW%7Bbackground-color%3Avar(--ds-background-input-pressed%2C%23fff)%7D%0A._0KLXruB4sa%7Bbackground-color%3Avar(--ds-background-inverse-subtle%2C%2300000029)%7D%0A._0KLXruVzWZ%7Bbackground-color%3Avar(--ds-background-inverse-subtle-hovered%2C%230000003d)%7D%0A._0KLXruTmu4%7Bbackground-color%3Avar(--ds-background-inverse-subtle-pressed%2C%2300000052)%7D%0A._0KLXruDMqu%7Bbackground-color%3Avar(--ds-background-neutral%2C%230515240f)%7D%0A._0KLXruKcZT%7Bbackground-color%3Avar(--ds-background-neutral-hovered%2C%230b120e24)%7D%0A._0KLXrunpTK%7Bbackground-color%3Avar(--ds-background-neutral-pressed%2C%23080f214a)%7D%0A._0KLXru66of%7Bbackground-color%3Avar(--ds-background-neutral-subtle%2C%2300000000)%7D%0A._0KLXruo126%7Bbackground-color%3Avar(--ds-background-neutral-subtle-hovered%2C%230515240f)%7D%0A._0KLXruN4oS%7Bbackground-color%3Avar(--ds-background-neutral-subtle-pressed%2C%230b120e24)%7D%0A._0KLXrugozt%7Bbackground-color%3Avar(--ds-background-neutral-bold%2C%23292a2e)%7D%0A._0KLXrukTlo%7Bbackground-color%3Avar(--ds-background-neutral-bold-hovered%2C%233b3d42)%7D%0A._0KLXruVbka%7Bbackground-color%3Avar(--ds-background-neutral-bold-pressed%2C%23505258)%7D%0A._0KLXruY9q9%7Bbackground-color%3Avar(--ds-background-selected%2C%23e9f2fe)%7D%0A._0KLXrusumd%7Bbackground-color%3Avar(--ds-background-selected-hovered%2C%23cfe1fd)%7D%0A._0KLXruXsxn%7Bbackground-color%3Avar(--ds-background-selected-pressed%2C%238fb8f6)%7D%0A._0KLXrukLmD%7Bbackground-color%3Avar(--ds-background-selected-bold%2C%231868db)%7D%0A._0KLXruXLOx%7Bbackground-color%3Avar(--ds-background-selected-bold-hovered%2C%231558bc)%7D%0A._0KLXruPSfI%7Bbackground-color%3Avar(--ds-background-selected-bold-pressed%2C%23123263)%7D%0A._0KLXrunl7T%7Bbackground-color%3Avar(--ds-background-brand-subtlest%2C%23e9f2fe)%7D%0A._0KLXruNPoG%7Bbackground-color%3Avar(--ds-background-brand-subtlest-hovered%2C%23cfe1fd)%7D%0A._0KLXruLKV0%7Bbackground-color%3Avar(--ds-background-brand-subtlest-pressed%2C%23adcbfb)%7D%0A._0KLXruDM2k%7Bbackground-color%3Avar(--ds-background-brand-bold%2C%231868db)%7D%0A._0KLXruhmrj%7Bbackground-color%3Avar(--ds-background-brand-bold-hovered%2C%231558bc)%7D%0A._0KLXruczkD%7Bbackground-color%3Avar(--ds-background-brand-bold-pressed%2C%23144794)%7D%0A._0KLXru2o0p%7Bbackground-color%3Avar(--ds-background-brand-boldest%2C%231c2b42)%7D%0A._0KLXruzGNP%7Bbackground-color%3Avar(--ds-background-brand-boldest-hovered%2C%23123263)%7D%0A._0KLXru9Y3T%7Bbackground-color%3Avar(--ds-background-brand-boldest-pressed%2C%23144794)%7D%0A._0KLXruhH7k%7Bbackground-color%3Avar(--ds-background-danger%2C%23ffeceb)%7D%0A._0KLXru1IMt%7Bbackground-color%3Avar(--ds-background-danger-hovered%2C%23ffd5d2)%7D%0A._0KLXruig7D%7Bbackground-color%3Avar(--ds-background-danger-pressed%2C%23ffb8b2)%7D%0A._0KLXruqsXs%7Bbackground-color%3Avar(--ds-background-danger-bold%2C%23c9372c)%7D%0A._0KLXruEISo%7Bbackground-color%3Avar(--ds-background-danger-bold-hovered%2C%23ae2e24)%7D%0A._0KLXruL5fL%7Bbackground-color%3Avar(--ds-background-danger-bold-pressed%2C%23872821)%7D%0A._0KLXruhxIM%7Bbackground-color%3Avar(--ds-background-warning%2C%23fff5db)%7D%0A._0KLXrudEDW%7Bbackground-color%3Avar(--ds-background-warning-hovered%2C%23fce4a6)%7D%0A._0KLXruiJjO%7Bbackground-color%3Avar(--ds-background-warning-pressed%2C%23fbd779)%7D%0A._0KLXruKLKE%7Bbackground-color%3Avar(--ds-background-warning-bold%2C%23fbc828)%7D%0A._0KLXruOCpk%7Bbackground-color%3Avar(--ds-background-warning-bold-hovered%2C%23fca700)%7D%0A._0KLXruSN2W%7Bbackground-color%3Avar(--ds-background-warning-bold-pressed%2C%23f68909)%7D%0A._0KLXruzaZe%7Bbackground-color%3Avar(--ds-background-success%2C%23efffd6)%7D%0A._0KLXruYQVR%7Bbackground-color%3Avar(--ds-background-success-hovered%2C%23d3f1a7)%7D%0A._0KLXruFj7I%7Bbackground-color%3Avar(--ds-background-success-pressed%2C%23bde97c)%7D%0A._0KLXruhbjP%7Bbackground-color%3Avar(--ds-background-success-bold%2C%235b7f24)%7D%0A._0KLXru1YDn%7Bbackground-color%3Avar(--ds-background-success-bold-hovered%2C%234c6b1f)%7D%0A._0KLXrulx7w%7Bbackground-color%3Avar(--ds-background-success-bold-pressed%2C%233f5224)%7D%0A._0KLXru94rk%7Bbackground-color%3Avar(--ds-background-discovery%2C%23f8eefe)%7D%0A._0KLXruaV2P%7Bbackground-color%3Avar(--ds-background-discovery-hovered%2C%23eed7fc)%7D%0A._0KLXruET5a%7Bbackground-color%3Avar(--ds-background-discovery-pressed%2C%23e3bdfa)%7D%0A._0KLXruqjHC%7Bbackground-color%3Avar(--ds-background-discovery-bold%2C%23964ac0)%7D%0A._0KLXrunIkF%7Bbackground-color%3Avar(--ds-background-discovery-bold-hovered%2C%23803fa5)%7D%0A._0KLXruSHT5%7Bbackground-color%3Avar(--ds-background-discovery-bold-pressed%2C%23673286)%7D%0A._0KLXrugNg3%7Bbackground-color%3Avar(--ds-background-information%2C%23e9f2fe)%7D%0A._0KLXruwQql%7Bbackground-color%3Avar(--ds-background-information-hovered%2C%23cfe1fd)%7D%0A._0KLXruB0Fx%7Bbackground-color%3Avar(--ds-background-information-pressed%2C%23adcbfb)%7D%0A._0KLXruASYT%7Bbackground-color%3Avar(--ds-background-information-bold%2C%231868db)%7D%0A._0KLXruGaQW%7Bbackground-color%3Avar(--ds-background-information-bold-hovered%2C%231558bc)%7D%0A._0KLXrujXMX%7Bbackground-color%3Avar(--ds-background-information-bold-pressed%2C%23144794)%7D%0A._0KLXruA5lS%7Bbackground-color%3Avar(--ds-blanket%2C%23050c1f75)%7D%0A._0KLXrumA7q%7Bbackground-color%3Avar(--ds-blanket-selected%2C%23388bff14)%7D%0A._0KLXrupOKR%7Bbackground-color%3Avar(--ds-blanket-danger%2C%23ef5c4814)%7D%0A._0KLXruGsB2%7Bbackground-color%3Avar(--ds-skeleton%2C%230515240f)%7D%0A._0KLXruaVjy%7Bbackground-color%3Avar(--ds-skeleton-subtle%2C%2317171708)%7D%0A._0KLXrulfZc%7Bbackground-color%3Avar(--ds-surface%2C%23fff)%7D%0A._0KLXrud1Zr%7Bbackground-color%3Avar(--ds-surface-hovered%2C%23f0f1f2)%7D%0A._0KLXruJNoT%7Bbackground-color%3Avar(--ds-surface-pressed%2C%23dddee1)%7D%0A._0KLXruoI2d%7Bbackground-color%3Avar(--ds-surface-overlay%2C%23fff)%7D%0A._0KLXruhWTW%7Bbackground-color%3Avar(--ds-surface-overlay-hovered%2C%23f0f1f2)%7D%0A._0KLXru0GoB%7Bbackground-color%3Avar(--ds-surface-overlay-pressed%2C%23dddee1)%7D%0A._0KLXruqi9L%7Bbackground-color%3Avar(--ds-surface-raised%2C%23fff)%7D%0A._0KLXrubvxc%7Bbackground-color%3Avar(--ds-surface-raised-hovered%2C%23f0f1f2)%7D%0A._0KLXruSEy3%7Bbackground-color%3Avar(--ds-surface-raised-pressed%2C%23dddee1)%7D%0A._0KLXrunmFW%7Bbackground-color%3Avar(--ds-surface-sunken%2C%23f8f8f8)%7D%0A._0KLXru4TrO%7Bbackground-color%3Avar(--ds-elevation-surface-current%2C%23fff)%7D%0A._45TjwHlfZc%7B--ds-elevation-surface-current%3Avar(--ds-surface%2C%23fff)%7D%0A._45TjwHd1Zr%7B--ds-elevation-surface-current%3Avar(--ds-surface-hovered%2C%23f0f1f2)%7D%0A._45TjwHJNoT%7B--ds-elevation-surface-current%3Avar(--ds-surface-pressed%2C%23dddee1)%7D%0A._45TjwHoI2d%7B--ds-elevation-surface-current%3Avar(--ds-surface-overlay%2C%23fff)%7D%0A._45TjwHhWTW%7B--ds-elevation-surface-current%3Avar(--ds-surface-overlay-hovered%2C%23f0f1f2)%7D%0A._45TjwH0GoB%7B--ds-elevation-surface-current%3Avar(--ds-surface-overlay-pressed%2C%23dddee1)%7D%0A._45TjwHqi9L%7B--ds-elevation-surface-current%3Avar(--ds-surface-raised%2C%23fff)%7D%0A._45TjwHbvxc%7B--ds-elevation-surface-current%3Avar(--ds-surface-raised-hovered%2C%23f0f1f2)%7D%0A._45TjwHSEy3%7B--ds-elevation-surface-current%3Avar(--ds-surface-raised-pressed%2C%23dddee1)%7D%0A._45TjwHnmFW%7B--ds-elevation-surface-current%3Avar(--ds-surface-sunken%2C%23f8f8f8)%7D%0A._46hvQmPgdg%7Bpadding-block-start%3Avar(--ds-space-0%2C0)%7D%0A._46hvQmFQfX%7Bpadding-block-start%3Avar(--ds-space-025%2C2px)%7D%0A._46hvQm1Y8M%7Bpadding-block-start%3Avar(--ds-space-050%2C4px)%7D%0A._46hvQmgVvo%7Bpadding-block-start%3Avar(--ds-space-075%2C6px)%7D%0A._46hvQm2ADO%7Bpadding-block-start%3Avar(--ds-space-100%2C8px)%7D%0A._46hvQm8HPE%7Bpadding-block-start%3Avar(--ds-space-150%2C9pt)%7D%0A._46hvQm5zaO%7Bpadding-block-start%3Avar(--ds-space-200%2C1pc)%7D%0A._46hvQmkG2W%7Bpadding-block-start%3Avar(--ds-space-250%2C20px)%7D%0A._46hvQmNHnM%7Bpadding-block-start%3Avar(--ds-space-300%2C24px)%7D%0A._46hvQmVa5s%7Bpadding-block-start%3Avar(--ds-space-400%2C2pc)%7D%0A._46hvQmS40j%7Bpadding-block-start%3Avar(--ds-space-500%2C40px)%7D%0A._46hvQmp0Oa%7Bpadding-block-start%3Avar(--ds-space-600%2C3pc)%7D%0A._46hvQmGXk2%7Bpadding-block-start%3Avar(--ds-space-800%2C4pc)%7D%0A._46hvQmyFLW%7Bpadding-block-start%3Avar(--ds-space-1000%2C5pc)%7D%0A._0xmtkoPgdg%7Bpadding-block-end%3Avar(--ds-space-0%2C0)%7D%0A._0xmtkoFQfX%7Bpadding-block-end%3Avar(--ds-space-025%2C2px)%7D%0A._0xmtko1Y8M%7Bpadding-block-end%3Avar(--ds-space-050%2C4px)%7D%0A._0xmtkogVvo%7Bpadding-block-end%3Avar(--ds-space-075%2C6px)%7D%0A._0xmtko2ADO%7Bpadding-block-end%3Avar(--ds-space-100%2C8px)%7D%0A._0xmtko8HPE%7Bpadding-block-end%3Avar(--ds-space-150%2C9pt)%7D%0A._0xmtko5zaO%7Bpadding-block-end%3Avar(--ds-space-200%2C1pc)%7D%0A._0xmtkokG2W%7Bpadding-block-end%3Avar(--ds-space-250%2C20px)%7D%0A._0xmtkoNHnM%7Bpadding-block-end%3Avar(--ds-space-300%2C24px)%7D%0A._0xmtkoVa5s%7Bpadding-block-end%3Avar(--ds-space-400%2C2pc)%7D%0A._0xmtkoS40j%7Bpadding-block-end%3Avar(--ds-space-500%2C40px)%7D%0A._0xmtkop0Oa%7Bpadding-block-end%3Avar(--ds-space-600%2C3pc)%7D%0A._0xmtkoGXk2%7Bpadding-block-end%3Avar(--ds-space-800%2C4pc)%7D%0A._0xmtkoyFLW%7Bpadding-block-end%3Avar(--ds-space-1000%2C5pc)%7D%0A._0LQT5EPgdg%7Bpadding-inline-start%3Avar(--ds-space-0%2C0)%7D%0A._0LQT5EFQfX%7Bpadding-inline-start%3Avar(--ds-space-025%2C2px)%7D%0A._0LQT5E1Y8M%7Bpadding-inline-start%3Avar(--ds-space-050%2C4px)%7D%0A._0LQT5EgVvo%7Bpadding-inline-start%3Avar(--ds-space-075%2C6px)%7D%0A._0LQT5E2ADO%7Bpadding-inline-start%3Avar(--ds-space-100%2C8px)%7D%0A._0LQT5E8HPE%7Bpadding-inline-start%3Avar(--ds-space-150%2C9pt)%7D%0A._0LQT5E5zaO%7Bpadding-inline-start%3Avar(--ds-space-200%2C1pc)%7D%0A._0LQT5EkG2W%7Bpadding-inline-start%3Avar(--ds-space-250%2C20px)%7D%0A._0LQT5ENHnM%7Bpadding-inline-start%3Avar(--ds-space-300%2C24px)%7D%0A._0LQT5EVa5s%7Bpadding-inline-start%3Avar(--ds-space-400%2C2pc)%7D%0A._0LQT5ES40j%7Bpadding-inline-start%3Avar(--ds-space-500%2C40px)%7D%0A._0LQT5Ep0Oa%7Bpadding-inline-start%3Avar(--ds-space-600%2C3pc)%7D%0A._0LQT5EGXk2%7Bpadding-inline-start%3Avar(--ds-space-800%2C4pc)%7D%0A._0LQT5EyFLW%7Bpadding-inline-start%3Avar(--ds-space-1000%2C5pc)%7D%0A._03SyCPPgdg%7Bpadding-inline-end%3Avar(--ds-space-0%2C0)%7D%0A._03SyCPFQfX%7Bpadding-inline-end%3Avar(--ds-space-025%2C2px)%7D%0A._03SyCP1Y8M%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D%0A._03SyCPgVvo%7Bpadding-inline-end%3Avar(--ds-space-075%2C6px)%7D%0A._03SyCP2ADO%7Bpadding-inline-end%3Avar(--ds-space-100%2C8px)%7D%0A._03SyCP8HPE%7Bpadding-inline-end%3Avar(--ds-space-150%2C9pt)%7D%0A._03SyCP5zaO%7Bpadding-inline-end%3Avar(--ds-space-200%2C1pc)%7D%0A._03SyCPkG2W%7Bpadding-inline-end%3Avar(--ds-space-250%2C20px)%7D%0A._03SyCPNHnM%7Bpadding-inline-end%3Avar(--ds-space-300%2C24px)%7D%0A._03SyCPVa5s%7Bpadding-inline-end%3Avar(--ds-space-400%2C2pc)%7D%0A._03SyCPS40j%7Bpadding-inline-end%3Avar(--ds-space-500%2C40px)%7D%0A._03SyCPp0Oa%7Bpadding-inline-end%3Avar(--ds-space-600%2C3pc)%7D%0A._03SyCPGXk2%7Bpadding-inline-end%3Avar(--ds-space-800%2C4pc)%7D%0A._03SyCPyFLW%7Bpadding-inline-end%3Avar(--ds-space-1000%2C5pc)%7D");









































































































































































































































































import { type ComponentPropsWithoutRef, type ComponentPropsWithRef, forwardRef, type JSX, type ReactElement, type ReactNode } from 'react';
import { type StrictXCSSProp, type XCSSAllProperties, type XCSSAllPseudos } from '@atlaskit/css';
import { SurfaceContext } from '../../utils/surface-context';
import type { BackgroundColorToken, SVGElements } from '../../utils/types';
import type { BasePrimitiveProps, PaddingToken, StyleProp, SurfaceColorToken } from './types';

// Can either Exclude or Extract - here we're excluding all SVG-related elements, <button> elements (handled by Pressable), and <a> elements (handled by Anchor)
type AllowedElements = Exclude<keyof JSX.IntrinsicElements, SVGElements | 'button' | 'a'>;

// Basically just ElementType but without ComponentType, it makes sense to keep the "Type" suffix
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
type CustomElementType<P = any> = { [K in AllowedElements]: P extends JSX.IntrinsicElements[K] ? K : never }[AllowedElements];
export type BoxProps<T extends CustomElementType> = Omit<ComponentPropsWithoutRef<T>, 'as' | 'className'> & Omit<BasePrimitiveProps, 'xcss' | 'style'> & BaseBoxProps<T>;
type BaseBoxProps<T extends CustomElementType> = {
  /**
   * The DOM element to render as the Box.
   * - This cannot be any SVG-related element such as `'svg'`, `'animate', `'circle'`, and many more
   * - This cannot be a `'a'` (use the `Anchor` primitive instead)
   * - This cannot be a `'button'` (use the `Anchor` primitive instead)
   * @default 'div'
   */
  as?: T;
  /**
   * Elements to be rendered inside the Box.
   */
  children?: ReactNode;
  /**
   * Token representing background color with a built-in fallback value.
   */
  backgroundColor?: SurfaceColorToken | BackgroundColorToken;
  /**
   * Tokens representing CSS shorthand for `paddingBlock` and `paddingInline` together.
   *
   * @see paddingBlock
   * @see paddingInline
   * @private
   * @deprecated – Do not use shorthand props, use `props.xcss` instead as these will be deprecated in the future.
   */
  padding?: PaddingToken;
  /**
   * Tokens representing CSS shorthand `paddingBlock`.
   *
   * @see paddingBlockStart
   * @see paddingBlockEnd
   * @private
   * @deprecated – Do not use shorthand props, use `props.xcss` instead as these will be deprecated in the future.
   */
  paddingBlock?: PaddingToken;
  /**
   * Tokens representing CSS `paddingBlockStart`.
   * @private
   * @deprecated – Do not use shorthand props, use `props.xcss` instead as these will be deprecated in the future.
   */
  paddingBlockStart?: PaddingToken;
  /**
   * Tokens representing CSS `paddingBlockEnd`.
   * @private
   * @deprecated – Do not use shorthand props, use `props.xcss` instead as these will be deprecated in the future.
   */
  paddingBlockEnd?: PaddingToken;
  /**
   * Tokens representing CSS shorthand `paddingInline`.
   * @private
   * @deprecated – Do not use shorthand props, use `props.xcss` instead as these will be deprecated in the future.
   *
   * @see paddingInlineStart
   * @see paddingInlineEnd
   */
  paddingInline?: PaddingToken;
  /**
   * Tokens representing CSS `paddingInlineStart`.
   * @private
   * @deprecated – Do not use shorthand props, use `props.xcss` instead as these will be deprecated in the future.
   */
  paddingInlineStart?: PaddingToken;
  /**
   * Tokens representing CSS `paddingInlineEnd`.
   * @private
   * @deprecated – Do not use shorthand props, use `props.xcss` instead as these will be deprecated in the future.
   */
  paddingInlineEnd?: PaddingToken;
  /**
   * Forwarded ref.
   */
  ref?: ComponentPropsWithRef<T>['ref'];
  /**
   * Inline styles to be applied to the Box. Only apply as a last resort, or where
   * styles cannot otherwise be calculated outside of the runtime of the component they're applied.
   */
  style?: Omit<StyleProp['style'], 'background' | 'backgroundColor'>;
  /**
   * Apply a subset of permitted styles powered by Atlassian Design System design tokens.
   * It's preferred you do not use `background` in `xcss` or `cssMap()` and instead use `props.backgroundColor` for surface awareness.
   */
  xcss?: StrictXCSSProp<Exclude<XCSSAllProperties, 'background'>, XCSSAllPseudos>;
};
type BoxComponent = <T extends CustomElementType>(props: BoxProps<T>) => ReactElement | null;
const baseStyles = null;
const backgroundColorMap = {
  'color.background.accent.lime.subtlest': "_0KLXruXL80",
  'color.background.accent.lime.subtlest.hovered': "_0KLXruL7r8",
  'color.background.accent.lime.subtlest.pressed': "_0KLXrulDnJ",
  'color.background.accent.lime.subtler': "_0KLXruuKDS",
  'color.background.accent.lime.subtler.hovered': "_0KLXruuIDk",
  'color.background.accent.lime.subtler.pressed': "_0KLXruyTNr",
  'color.background.accent.lime.subtle': "_0KLXruZcd0",
  'color.background.accent.lime.subtle.hovered': "_0KLXrude7x",
  'color.background.accent.lime.subtle.pressed': "_0KLXrum9Fz",
  'color.background.accent.lime.bolder': "_0KLXrubYhN",
  'color.background.accent.lime.bolder.hovered': "_0KLXruaWdC",
  'color.background.accent.lime.bolder.pressed': "_0KLXruCN3C",
  'color.background.accent.red.subtlest': "_0KLXrusDFP",
  'color.background.accent.red.subtlest.hovered': "_0KLXruIg5O",
  'color.background.accent.red.subtlest.pressed': "_0KLXruElzn",
  'color.background.accent.red.subtler': "_0KLXrubV9i",
  'color.background.accent.red.subtler.hovered': "_0KLXruFOVf",
  'color.background.accent.red.subtler.pressed': "_0KLXruFnU8",
  'color.background.accent.red.subtle': "_0KLXru0cUQ",
  'color.background.accent.red.subtle.hovered': "_0KLXruIt8U",
  'color.background.accent.red.subtle.pressed': "_0KLXrunRhf",
  'color.background.accent.red.bolder': "_0KLXruQrW1",
  'color.background.accent.red.bolder.hovered': "_0KLXrumCVf",
  'color.background.accent.red.bolder.pressed': "_0KLXruPm25",
  'color.background.accent.orange.subtlest': "_0KLXru2QQR",
  'color.background.accent.orange.subtlest.hovered': "_0KLXru629A",
  'color.background.accent.orange.subtlest.pressed': "_0KLXrupg0Z",
  'color.background.accent.orange.subtler': "_0KLXruwJ86",
  'color.background.accent.orange.subtler.hovered': "_0KLXruEo5I",
  'color.background.accent.orange.subtler.pressed': "_0KLXru78bI",
  'color.background.accent.orange.subtle': "_0KLXruuwVU",
  'color.background.accent.orange.subtle.hovered': "_0KLXrunwBH",
  'color.background.accent.orange.subtle.pressed': "_0KLXruKHmw",
  'color.background.accent.orange.bolder': "_0KLXrux4f7",
  'color.background.accent.orange.bolder.hovered': "_0KLXruwYNk",
  'color.background.accent.orange.bolder.pressed': "_0KLXruDYlO",
  'color.background.accent.yellow.subtlest': "_0KLXru56u3",
  'color.background.accent.yellow.subtlest.hovered': "_0KLXruBwZU",
  'color.background.accent.yellow.subtlest.pressed': "_0KLXruHN5H",
  'color.background.accent.yellow.subtler': "_0KLXruLv9B",
  'color.background.accent.yellow.subtler.hovered': "_0KLXruJMtC",
  'color.background.accent.yellow.subtler.pressed': "_0KLXruVvUp",
  'color.background.accent.yellow.subtle': "_0KLXruC29w",
  'color.background.accent.yellow.subtle.hovered': "_0KLXruSF9i",
  'color.background.accent.yellow.subtle.pressed': "_0KLXruOIUD",
  'color.background.accent.yellow.bolder': "_0KLXruYB6L",
  'color.background.accent.yellow.bolder.hovered': "_0KLXru5gSm",
  'color.background.accent.yellow.bolder.pressed': "_0KLXruTjon",
  'color.background.accent.green.subtlest': "_0KLXruV6wL",
  'color.background.accent.green.subtlest.hovered': "_0KLXruMqh8",
  'color.background.accent.green.subtlest.pressed': "_0KLXruUxn0",
  'color.background.accent.green.subtler': "_0KLXruNUep",
  'color.background.accent.green.subtler.hovered': "_0KLXruSZVv",
  'color.background.accent.green.subtler.pressed': "_0KLXruratX",
  'color.background.accent.green.subtle': "_0KLXru50ZN",
  'color.background.accent.green.subtle.hovered': "_0KLXru6mZS",
  'color.background.accent.green.subtle.pressed': "_0KLXruIBxe",
  'color.background.accent.green.bolder': "_0KLXrude1t",
  'color.background.accent.green.bolder.hovered': "_0KLXruB5SF",
  'color.background.accent.green.bolder.pressed': "_0KLXruLYGL",
  'color.background.accent.teal.subtlest': "_0KLXruuBpz",
  'color.background.accent.teal.subtlest.hovered': "_0KLXrugqYx",
  'color.background.accent.teal.subtlest.pressed': "_0KLXrufBlI",
  'color.background.accent.teal.subtler': "_0KLXrunfgW",
  'color.background.accent.teal.subtler.hovered': "_0KLXruA8mq",
  'color.background.accent.teal.subtler.pressed': "_0KLXrujHQE",
  'color.background.accent.teal.subtle': "_0KLXrufjGw",
  'color.background.accent.teal.subtle.hovered': "_0KLXrubjxt",
  'color.background.accent.teal.subtle.pressed': "_0KLXruUDSb",
  'color.background.accent.teal.bolder': "_0KLXruzHaB",
  'color.background.accent.teal.bolder.hovered': "_0KLXrunc80",
  'color.background.accent.teal.bolder.pressed': "_0KLXruu11s",
  'color.background.accent.blue.subtlest': "_0KLXruVva3",
  'color.background.accent.blue.subtlest.hovered': "_0KLXruotmK",
  'color.background.accent.blue.subtlest.pressed': "_0KLXruxyGe",
  'color.background.accent.blue.subtler': "_0KLXrup9dS",
  'color.background.accent.blue.subtler.hovered': "_0KLXruRRyT",
  'color.background.accent.blue.subtler.pressed': "_0KLXrueeqx",
  'color.background.accent.blue.subtle': "_0KLXru28sy",
  'color.background.accent.blue.subtle.hovered': "_0KLXruKSSk",
  'color.background.accent.blue.subtle.pressed': "_0KLXru40Rv",
  'color.background.accent.blue.bolder': "_0KLXrutfbE",
  'color.background.accent.blue.bolder.hovered': "_0KLXruupqB",
  'color.background.accent.blue.bolder.pressed': "_0KLXru36Hh",
  'color.background.accent.purple.subtlest': "_0KLXruB8KG",
  'color.background.accent.purple.subtlest.hovered': "_0KLXrueJK9",
  'color.background.accent.purple.subtlest.pressed': "_0KLXruhT4j",
  'color.background.accent.purple.subtler': "_0KLXruWOdT",
  'color.background.accent.purple.subtler.hovered': "_0KLXrujgGS",
  'color.background.accent.purple.subtler.pressed': "_0KLXruWgRz",
  'color.background.accent.purple.subtle': "_0KLXruf89Q",
  'color.background.accent.purple.subtle.hovered': "_0KLXru46BV",
  'color.background.accent.purple.subtle.pressed': "_0KLXruU9Hm",
  'color.background.accent.purple.bolder': "_0KLXruhdss",
  'color.background.accent.purple.bolder.hovered': "_0KLXruXxp4",
  'color.background.accent.purple.bolder.pressed': "_0KLXru1L16",
  'color.background.accent.magenta.subtlest': "_0KLXru8frT",
  'color.background.accent.magenta.subtlest.hovered': "_0KLXruWeuD",
  'color.background.accent.magenta.subtlest.pressed': "_0KLXruK9iC",
  'color.background.accent.magenta.subtler': "_0KLXruXM4x",
  'color.background.accent.magenta.subtler.hovered': "_0KLXrukPhQ",
  'color.background.accent.magenta.subtler.pressed': "_0KLXruGjVz",
  'color.background.accent.magenta.subtle': "_0KLXrupmfs",
  'color.background.accent.magenta.subtle.hovered': "_0KLXruexkg",
  'color.background.accent.magenta.subtle.pressed': "_0KLXruV3kb",
  'color.background.accent.magenta.bolder': "_0KLXruxE6Y",
  'color.background.accent.magenta.bolder.hovered': "_0KLXruPb8Y",
  'color.background.accent.magenta.bolder.pressed': "_0KLXruwQL0",
  'color.background.accent.gray.subtlest': "_0KLXrumhAQ",
  'color.background.accent.gray.subtlest.hovered': "_0KLXruBee8",
  'color.background.accent.gray.subtlest.pressed': "_0KLXruysrI",
  'color.background.accent.gray.subtler': "_0KLXruG6qS",
  'color.background.accent.gray.subtler.hovered': "_0KLXruXljP",
  'color.background.accent.gray.subtler.pressed': "_0KLXru6vdf",
  'color.background.accent.gray.subtle': "_0KLXrueZ10",
  'color.background.accent.gray.subtle.hovered': "_0KLXruY62e",
  'color.background.accent.gray.subtle.pressed': "_0KLXruvFnq",
  'color.background.accent.gray.bolder': "_0KLXrurxgm",
  'color.background.accent.gray.bolder.hovered': "_0KLXruW5tB",
  'color.background.accent.gray.bolder.pressed': "_0KLXrunA18",
  'color.background.disabled': "_0KLXruVrZW",
  'color.background.input': "_0KLXru7Cj1",
  'color.background.input.hovered': "_0KLXruqWX3",
  'color.background.input.pressed': "_0KLXruutHW",
  'color.background.inverse.subtle': "_0KLXruB4sa",
  'color.background.inverse.subtle.hovered': "_0KLXruVzWZ",
  'color.background.inverse.subtle.pressed': "_0KLXruTmu4",
  'color.background.neutral': "_0KLXruDMqu",
  'color.background.neutral.hovered': "_0KLXruKcZT",
  'color.background.neutral.pressed': "_0KLXrunpTK",
  'color.background.neutral.subtle': "_0KLXru66of",
  'color.background.neutral.subtle.hovered': "_0KLXruo126",
  'color.background.neutral.subtle.pressed': "_0KLXruN4oS",
  'color.background.neutral.bold': "_0KLXrugozt",
  'color.background.neutral.bold.hovered': "_0KLXrukTlo",
  'color.background.neutral.bold.pressed': "_0KLXruVbka",
  'color.background.selected': "_0KLXruY9q9",
  'color.background.selected.hovered': "_0KLXrusumd",
  'color.background.selected.pressed': "_0KLXruXsxn",
  'color.background.selected.bold': "_0KLXrukLmD",
  'color.background.selected.bold.hovered': "_0KLXruXLOx",
  'color.background.selected.bold.pressed': "_0KLXruPSfI",
  'color.background.brand.subtlest': "_0KLXrunl7T",
  'color.background.brand.subtlest.hovered': "_0KLXruNPoG",
  'color.background.brand.subtlest.pressed': "_0KLXruLKV0",
  'color.background.brand.bold': "_0KLXruDM2k",
  'color.background.brand.bold.hovered': "_0KLXruhmrj",
  'color.background.brand.bold.pressed': "_0KLXruczkD",
  'color.background.brand.boldest': "_0KLXru2o0p",
  'color.background.brand.boldest.hovered': "_0KLXruzGNP",
  'color.background.brand.boldest.pressed': "_0KLXru9Y3T",
  'color.background.danger': "_0KLXruhH7k",
  'color.background.danger.hovered': "_0KLXru1IMt",
  'color.background.danger.pressed': "_0KLXruig7D",
  'color.background.danger.bold': "_0KLXruqsXs",
  'color.background.danger.bold.hovered': "_0KLXruEISo",
  'color.background.danger.bold.pressed': "_0KLXruL5fL",
  'color.background.warning': "_0KLXruhxIM",
  'color.background.warning.hovered': "_0KLXrudEDW",
  'color.background.warning.pressed': "_0KLXruiJjO",
  'color.background.warning.bold': "_0KLXruKLKE",
  'color.background.warning.bold.hovered': "_0KLXruOCpk",
  'color.background.warning.bold.pressed': "_0KLXruSN2W",
  'color.background.success': "_0KLXruzaZe",
  'color.background.success.hovered': "_0KLXruYQVR",
  'color.background.success.pressed': "_0KLXruFj7I",
  'color.background.success.bold': "_0KLXruhbjP",
  'color.background.success.bold.hovered': "_0KLXru1YDn",
  'color.background.success.bold.pressed': "_0KLXrulx7w",
  'color.background.discovery': "_0KLXru94rk",
  'color.background.discovery.hovered': "_0KLXruaV2P",
  'color.background.discovery.pressed': "_0KLXruET5a",
  'color.background.discovery.bold': "_0KLXruqjHC",
  'color.background.discovery.bold.hovered': "_0KLXrunIkF",
  'color.background.discovery.bold.pressed': "_0KLXruSHT5",
  'color.background.information': "_0KLXrugNg3",
  'color.background.information.hovered': "_0KLXruwQql",
  'color.background.information.pressed': "_0KLXruB0Fx",
  'color.background.information.bold': "_0KLXruASYT",
  'color.background.information.bold.hovered': "_0KLXruGaQW",
  'color.background.information.bold.pressed': "_0KLXrujXMX",
  'color.blanket': "_0KLXruA5lS",
  'color.blanket.selected': "_0KLXrumA7q",
  'color.blanket.danger': "_0KLXrupOKR",
  'color.skeleton': "_0KLXruGsB2",
  'color.skeleton.subtle': "_0KLXruaVjy",
  'elevation.surface': "_0KLXrulfZc",
  'elevation.surface.hovered': "_0KLXrud1Zr",
  'elevation.surface.pressed': "_0KLXruJNoT",
  'elevation.surface.overlay': "_0KLXruoI2d",
  'elevation.surface.overlay.hovered': "_0KLXruhWTW",
  'elevation.surface.overlay.pressed': "_0KLXru0GoB",
  'elevation.surface.raised': "_0KLXruqi9L",
  'elevation.surface.raised.hovered': "_0KLXrubvxc",
  'elevation.surface.raised.pressed': "_0KLXruSEy3",
  'elevation.surface.sunken': "_0KLXrunmFW",
  'utility.elevation.surface.current': "_0KLXru4TrO"
};
const CURRENT_SURFACE_CSS_VAR = (`--ds-elevation-surface-current` as const);
const setSurfaceTokenMap = {
  'elevation.surface': "_45TjwHlfZc",
  'elevation.surface.hovered': "_45TjwHd1Zr",
  'elevation.surface.pressed': "_45TjwHJNoT",
  'elevation.surface.overlay': "_45TjwHoI2d",
  'elevation.surface.overlay.hovered': "_45TjwHhWTW",
  'elevation.surface.overlay.pressed': "_45TjwH0GoB",
  'elevation.surface.raised': "_45TjwHqi9L",
  'elevation.surface.raised.hovered': "_45TjwHbvxc",
  'elevation.surface.raised.pressed': "_45TjwHSEy3",
  'elevation.surface.sunken': "_45TjwHnmFW"
};
const paddingBlockStartMap = {
  'space.0': "_46hvQmPgdg",
  'space.025': "_46hvQmFQfX",
  'space.050': "_46hvQm1Y8M",
  'space.075': "_46hvQmgVvo",
  'space.100': "_46hvQm2ADO",
  'space.150': "_46hvQm8HPE",
  'space.200': "_46hvQm5zaO",
  'space.250': "_46hvQmkG2W",
  'space.300': "_46hvQmNHnM",
  'space.400': "_46hvQmVa5s",
  'space.500': "_46hvQmS40j",
  'space.600': "_46hvQmp0Oa",
  'space.800': "_46hvQmGXk2",
  'space.1000': "_46hvQmyFLW"
};
const paddingBlockEndMap = {
  'space.0': "_0xmtkoPgdg",
  'space.025': "_0xmtkoFQfX",
  'space.050': "_0xmtko1Y8M",
  'space.075': "_0xmtkogVvo",
  'space.100': "_0xmtko2ADO",
  'space.150': "_0xmtko8HPE",
  'space.200': "_0xmtko5zaO",
  'space.250': "_0xmtkokG2W",
  'space.300': "_0xmtkoNHnM",
  'space.400': "_0xmtkoVa5s",
  'space.500': "_0xmtkoS40j",
  'space.600': "_0xmtkop0Oa",
  'space.800': "_0xmtkoGXk2",
  'space.1000': "_0xmtkoyFLW"
};
const paddingInlineStartMap = {
  'space.0': "_0LQT5EPgdg",
  'space.025': "_0LQT5EFQfX",
  'space.050': "_0LQT5E1Y8M",
  'space.075': "_0LQT5EgVvo",
  'space.100': "_0LQT5E2ADO",
  'space.150': "_0LQT5E8HPE",
  'space.200': "_0LQT5E5zaO",
  'space.250': "_0LQT5EkG2W",
  'space.300': "_0LQT5ENHnM",
  'space.400': "_0LQT5EVa5s",
  'space.500': "_0LQT5ES40j",
  'space.600': "_0LQT5Ep0Oa",
  'space.800': "_0LQT5EGXk2",
  'space.1000': "_0LQT5EyFLW"
};
const paddingInlineEndMap = {
  'space.0': "_03SyCPPgdg",
  'space.025': "_03SyCPFQfX",
  'space.050': "_03SyCP1Y8M",
  'space.075': "_03SyCPgVvo",
  'space.100': "_03SyCP2ADO",
  'space.150': "_03SyCP8HPE",
  'space.200': "_03SyCP5zaO",
  'space.250': "_03SyCPkG2W",
  'space.300': "_03SyCPNHnM",
  'space.400': "_03SyCPVa5s",
  'space.500': "_03SyCPS40j",
  'space.600': "_03SyCPp0Oa",
  'space.800': "_03SyCPGXk2",
  'space.1000': "_03SyCPyFLW"
};

/**
 * __Box__
 *
 * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
 * Renders a `div` by default.
 *
 * - [Examples](https://atlassian.design/components/primitives/box/examples)
 * - [Code](https://atlassian.design/components/primitives/box/code)
 * - [Usage](https://atlassian.design/components/primitives/box/usage)
 */
export const Box = (forwardRef(<T extends CustomElementType,>({
  as: Component = ('div' as T),
  children,
  backgroundColor,
  padding,
  paddingBlock = padding,
  paddingBlockStart = paddingBlock,
  paddingBlockEnd = paddingBlock,
  paddingInline = padding,
  paddingInlineStart = paddingInline,
  paddingInlineEnd = paddingInline,
  style,
  testId,
  xcss,
  ...htmlAttributes
}: BoxProps<T>, ref: BoxProps<T>['ref']) => {
  // This is to remove className from safeHtmlAttributes
  // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
  const {
    className: _spreadClass,
    ...safeHtmlAttributes
  } = htmlAttributes;
  const node = <Component style={style}
  // @ts-ignore -- Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
  ref={ref} className={ax(["_30huDKYbGa _24h04i2Njc _034jHtYbGa", backgroundColor && backgroundColorMap[backgroundColor], backgroundColor && isSurfaceToken(backgroundColor) && setSurfaceTokenMap[backgroundColor], paddingBlockStart && paddingBlockStartMap[paddingBlockStart], paddingBlockEnd && paddingBlockEndMap[paddingBlockEnd], paddingInlineStart && paddingInlineStartMap[paddingInlineStart], paddingInlineEnd && paddingInlineEndMap[paddingInlineEnd], xcss])} {...safeHtmlAttributes} data-testid={testId}>
				{children}
			</Component>;
  if (backgroundColor) {
    return <SurfaceContext.Provider value={backgroundColor}>{node}</SurfaceContext.Provider>;
  }
  return node;
}
// The return type of `BoxComponent` does not match the return type of `forwardRef` in React 18
) as BoxComponent);
function isSurfaceToken(backgroundColor: string): backgroundColor is keyof typeof setSurfaceTokenMap {
  return backgroundColor in setSurfaceTokenMap;
}